export const FETCH_EMAILALERT_DATA = 'FETCH_EMAILALERT_DATA';
export const FETCH_EMAILALERT_DATA_SUCCESS = 'FETCH_EMAILALERT_DATA_SUCCESS';
export const FETCH_EMAILALERT_DATA_FAILURE = 'FETCH_EMAILALERT_DATA_FAILURE';
export const SAVE_EMAILALERT_DATA = 'SAVE_EMAILALERT_DATA';
export const SAVE_EMAILALERT_DATA_SUCCESS = 'SAVE_EMAILALERT_DATA_SUCCESS';
export const SAVE_EMAILALERT_DATA_FAILURE = 'SAVE_EMAILALERT_DATA_FAILURE';
